import React from 'react';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/system';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebase';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: 48,
    height: 48,
    backgroundColor: "#0074d9",
    color: "#fff",
    fontSize: 24,
    fontWeight: 'bold',
}));

const EmailAvatar = () => {
    const [email, setEmail] = React.useState('');

    React.useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setEmail(user.email);
            } else {
                setEmail('');
            }
        });

        return () => unsubscribe();
    }, []);

    const firstLetter = email ? email.charAt(0).toUpperCase() : '';

    return (
        <StyledAvatar>{firstLetter}</StyledAvatar>
    );
};

export default EmailAvatar;
